<div class="menu-container" *ngIf="
    currentUser?.role === 'superAdmin' ||
    currentUser?.role === 'admin' ||
    currentUser?.role === 'manager' ||
    currentUser?.role === 'accountant' ||
    currentUser?.role === 'support' ||
    currentUser?.role === 'company'
  ">
  <!-- Header Section -->
  <div class="sidebar-header" style="display: flex; flex-direction: column;">
    <div class="logo-section">
      <div class="logo-text">
        <img src="/assets/bbbb.png" alt="Aunak Logo" style="max-height: 54px !important; width: 100%; height: 100%;">
      </div>
    </div>
    <div
      style="width: 100%; text-align: center; font-size: 12px; color: #787878; padding: 0 12px;">
      V0.0.2 - Sept 2026
    </div>
  </div>

  <!-- Navigation Menu -->
  <ul class="nav-menu" style="padding-bottom: 5rem !important;">
    <li *ngFor="let item of visibleItems; trackBy: trackByLink" class="nav-item">
      <a [href]="item.link" class="nav-link" [class.active-link]="isActive(item.link)" [title]="item.label"
        (click)="go(item.link, $event)">
        <i class="bi {{ item.icon }} nav-icon"></i>
        <span class="nav-label">{{ item.label }}</span>
        <span *ngIf="item.showValue && item.value > 0" class="nav-badge">{{ item.value }}</span>
      </a>
    </li>
  </ul>

  <div *ngIf="currentUser?.role === 'company'"
    style="bottom: 0; left: 0; right: 0; position: absolute; min-height: 46px;">
    <div class="bottom-menu-container">
      <a class="bottom-menu-item" routerLink="/profile" routerLinkActive="active-bottom-link">
        <i class="bi bi-person-fill"></i>
      </a>
      <ng-container *ngFor="let item of bottomCompanyMenu">
        <a *ngIf="item.externalUrl" class="bottom-menu-item" [href]="item.externalUrl" target="_blank"
          rel="noopener noreferrer" [title]="item.label">
          <i class="bi {{ item.icon }}"></i>
        </a>
        <a *ngIf="!item.externalUrl" class="bottom-menu-item" [routerLink]="item.link"
          routerLinkActive="active-bottom-link" [title]="item.label">
          <i class="bi {{ item.icon }}"></i>
        </a>
      </ng-container>
    </div>
  </div>



  <div *ngIf="showAdminBottomBar()" style="bottom: 0; left: 0; right: 0; position: absolute; min-height: 46px;">
    <div class="bottom-menu-container">
      <a class="bottom-menu-item" routerLink="/admin/profile" routerLinkActive="active-bottom-link">
        <i class="bi bi-person-fill"></i>
      </a>
      <ng-container *ngFor="let item of bottomAdminMenu">
        <a *ngIf="item.externalUrl" class="bottom-menu-item" [href]="item.externalUrl" target="_blank"
          rel="noopener noreferrer" [title]="item.label">
          <i class="bi {{ item.icon }}"></i>
        </a>
        <a *ngIf="!item.externalUrl" class="bottom-menu-item" [routerLink]="item.link"
          routerLinkActive="active-bottom-link" [title]="item.label">
          <i class="bi {{ item.icon }}"></i>
        </a>
      </ng-container>
    </div>
  </div>
</div>